import React from 'react';

import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';

import type { CardLabels } from '@/types/packageCard';

interface CardMetaInfoProps {
  testType?: string | null;
  gender?: string | null;
  labels: CardLabels;
  showReferral?: boolean;
  showGender?: boolean;
}

export default function CardMetaInfo({
  testType,
  gender,
  labels,
  showReferral = true,
  showGender = true,
}: CardMetaInfoProps): React.ReactElement | null {
  if (!showReferral && !showGender) return null;

  return (
    <div
      className={`mt-4 grid gap-4 ${
        showReferral && showGender ? 'grid-cols-2' : 'grid-cols-1'
      }`}
    >
      {showReferral && (
        <div className="flex items-start">
          <R2Image
            path="/images/healthpackages/no-referral-required.svg"
            alt="Test type"
            width={20}
            height={20}
            className="shrink-0 object-contain"
          />
          <div className="ml-2">
            <RichText styles={labels.referralLabel?.styles}>
              {labels.referralLabel?.content ?? 'Referral'}
            </RichText>
            {testType && (
              <RichText styles={labels.testTypeValue?.styles}>
                {testType}
              </RichText>
            )}
          </div>
        </div>
      )}
      {showGender && (
        <div className="flex items-start">
          <R2Image
            path="/images/healthpackages/gender-icon.svg"
            alt="Gender"
            width={20}
            height={20}
            className="shrink-0 object-contain"
          />
          <div className="ml-2">
            <RichText styles={labels.genderLabel?.styles}>
              {labels.genderLabel?.content ?? 'Gender'}
            </RichText>
            {gender && (
              <RichText styles={labels.genderValue?.styles}>{gender}</RichText>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
